import { Component } from '@angular/core';

@Component({
  templateUrl: '404.component.html',
  selector: 'twaice-fe-404',
  standalone: false,
})
export class P404Component {}
